import { render, staticRenderFns } from "./lp-investment-like-no-other-i.vue?vue&type=template&id=4e7d6105&scoped=true"
import script from "./lp-investment-like-no-other-i.vue?vue&type=script&lang=js"
export * from "./lp-investment-like-no-other-i.vue?vue&type=script&lang=js"
import style0 from "./lp-investment-like-no-other-i.vue?vue&type=style&index=0&id=4e7d6105&prod&scoped=true&lang=css"
import style1 from "./lp-investment-like-no-other-i.vue?vue&type=style&index=1&id=4e7d6105&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7d6105",
  null
  
)

export default component.exports